/* global $ */

import toArray from '../helpers/toArray';
import { getClosest } from '../helpers/DOMManipulation';

const StatefulTabs = {

  /**
   * Create tabs component that handles URL hashes for navigation
   * @param {Node} node
   * @return {void}
   */
  create(node) {
    this.node = node;

    this.getTabIDs();

    this.getTabs().forEach((tab) => {
      tab.addEventListener('click', this.onTabClick.bind(this));
    });

    if (window.location.hash) {
      this.matchTabToHash(window.location.hash);
    }
  },

  /**
   * Remove hash from the string
   * @param {String} str
   * @return {String}
   */
  removeHash(str) { return str.replace(/^#/, ''); },

  /**
   * Get all tab nodes
   * @return {Array} Array with DOM nodes
   */
  getTabs() {
    return toArray(this.node.querySelectorAll('.nav-link'));
  },

  /**
   * Get and save the ID's of tabs
   * @return {void}
   */
  getTabIDs() {
    this.ids = this.getTabs().map(tab => this.removeHash(tab.getAttribute('href')));
  },

  /**
   * Get the tab that matches the location hash
   * @param {String} hash
   * @return {void}
   */
  matchTabToHash(hash) {
    const index = this.ids.indexOf(this.removeHash(hash));

    if (index >= 0) {
      const id = this.ids[index];

      // Loop through tabs and check if one of them matches the URL hash
      this.getTabs().forEach((tab) => {
        if (this.removeHash(tab.getAttribute('href')) === id) {
          $(tab).tab('show');
        }
      });
    }
  },

  /**
   * Handle clicks on tabs
   * @param {Object} e Event object
   * @return {void}
   */
  onTabClick(e) {
    // Get the tab link
    const tab = getClosest(e.target, '.nav-link');

    // Check if the element is found and we've support for the History API
    if (tab && typeof window.history.replaceState !== 'undefined') {
      // Get the ID of the tab
      const hash = tab.getAttribute('href');

      // Change the URL with the new hash
      window.history.replaceState(null, null, hash);
    }
  },
};

export default StatefulTabs;
